import classNames from 'classnames'
import CircleLoader from '@components/CircleLoader'
import Icon from '@components/Icon'
import './styles.scss'

/*
 * All 'buttonProps' will be passed into the <button> or <a> element
 */

const Button = ({
    btnStyle,
    isLoading,
    children,
    href,
    className,
    block,
    size,
    iconLeft,
    iconRight,
    external,
    align,
    inline,
    ...buttonProps
}) => {
    const Element = external ? 'a' : href ? Link : 'button'
    const to = external ? { href, target: '__blank' } : href ? { to: href } : {}
    const loaderColor = btnStyle === 'primary' ? 'light' : undefined
    const iconSize = size === 'small' ? 'xxs' : 'xs'

    const classList = classNames('brand-button', {
        'is-disabled': buttonProps.disabled,
        'brand-button--loading': isLoading,
        'brand-button--block': block,
        [`brand-button--${btnStyle}`]: btnStyle,
        [`brand-button--${size}`]: size,
        [`brand-button--${align}`]: align,
        'brand-button--inline': inline,
        'brand-button--icon-left': iconLeft,
        'brand-button--icon-right': iconRight,
        'brand-button--opngo': iconRight === 'opngo',
        [`${className}`]: className,
    })

    return (
        <Element {...buttonProps} {...to} className={classList}>
            {isLoading && (
                <div className="brand-button__loader">
                    <CircleLoader size="small" color={loaderColor} />
                </div>
            )}

            {iconLeft && <Icon type={iconLeft} size={iconSize} className="brand-button__icon" />}
            <div className="brand-button__text">{children}</div>

            {iconRight && (
                <div className="brand-button__suffix">
                    <Icon type={iconRight} size={iconSize} className="brand-button__icon" />
                </div>
            )}
        </Element>
    )
}

Button.propTypes = {
    href: PropTypes.string,
    isLoading: PropTypes.bool,
    className: PropTypes.string,
    btnStyle: PropTypes.oneOf(['primary', 'outline', 'link']),
    size: PropTypes.oneOf(['small', 'large']),
    iconLeft: PropTypes.string,
    iconRight: PropTypes.string,
    block: PropTypes.bool,
    // Horizontal alignment
    align: PropTypes.oneOf(['left', 'center', 'right']),
    // Whether the href points to external or app-internal url
    external: PropTypes.bool,
}

Button.defaultProps = {
    btnStyle: 'primary',
    block: false,
}

export default Button
